import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { DISTANT, sliderConfig, tokens } from '../../constants';
export var applyStep = (val, step) => {
  if (step !== undefined && step > 0) {
    return Math.round(val / step) * step;
  }
  return val;
};
export var getSliderStyles = (props, isMobile) => {
  var _a, _b;
  var config = props.config;
  var _tokens$spacing = tokens.spacing,
    SPACING_4 = _tokens$spacing.SPACING_4,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_16 = _tokens$spacing.SPACING_16;
  var mobileConfig = (_a = config === null || config === void 0 ? void 0 : config.platform) === null || _a === void 0 ? void 0 : _a.mobile;
  var desktopConfig = (_b = config === null || config === void 0 ? void 0 : config.platform) === null || _b === void 0 ? void 0 : _b.desktop;
  var thumbSize = isMobile ? mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.thumbSize : desktopConfig === null || desktopConfig === void 0 ? void 0 : desktopConfig.thumbSize;
  var thumbBorderWidth = isMobile ? mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.thumbBorderWidth : desktopConfig === null || desktopConfig === void 0 ? void 0 : desktopConfig.thumbBorderWidth;
  return StyleSheet.create({
    containerWrapper: {
      paddingTop: isMobile ? SPACING_12 : SPACING_16,
      paddingBottom: isMobile ? SPACING_8 : SPACING_16,
      cursor: 'pointer'
    },
    container: {
      position: 'relative',
      backgroundColor: config.trackProgressColor,
      height: isMobile ? mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.trackHeigh : desktopConfig === null || desktopConfig === void 0 ? void 0 : desktopConfig.trackHeigh,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_8
    },
    thumb: Object.assign(Object.assign(Object.assign({}, StyleSheet.absoluteFillObject), {
      top: -(thumbSize / 2) + thumbBorderWidth / 2,
      height: thumbSize,
      width: thumbSize,
      backgroundColor: config.trackBackgroundColor,
      borderWidth: thumbBorderWidth,
      borderColor: config.thumbBorderColor,
      borderRadius: 100,
      zIndex: 1,
      cursor: 'pointer'
    }), DISTANT),
    track: Object.assign(Object.assign({}, StyleSheet.absoluteFillObject), {
      height: '100%',
      width: 0,
      backgroundColor: config.trackBackgroundColor,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_8,
      cursor: 'pointer'
    }),
    startEndTextContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    endText: {
      marginLeft: SPACING_8
    },
    fieldContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: SPACING_4
    }
  });
};
export var getSliderProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(sliderConfig === null || sliderConfig === void 0 ? void 0 : sliderConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.slider) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};